export enum PRE_CAMPAIGN_DEPOSIT_TYPES {
  Monthly = 0,
  OfThePrice = 1,
}